module.exports = __webpack_public_path__ + "static/franky-9f9dc6171d2aa45b7a30184640133014.jpg";